<template>
  <!-- 参照可能営業所 -->
  <div id="AppUserManagementReferenceOffice">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--参照可能ユーザ -->
    <div class="columns" v-if="canManagerChangeActive">
      <div class="column">
        <b-field label="ユーザ" labelPosition="on-border">
          <b-input expanded :readonly="true" v-model="data.staffName"></b-input>
          <b-button
            style="float:right; bottom:0;"
            class="button is-primary has-text-centered"
            icon-left="account-switch"
            native-type="button"
            v-on:click="changeStaff"
          ></b-button>
          <b-modal :active.sync="isManagerChangeActive" has-modal-card>
            <staffChange-modal v-on:staff-change-event="staffChanged"></staffChange-modal>
          </b-modal>
        </b-field>
      </div>
    </div>
    <div class="columns selectdiv">
      <div class="column">
        <table>
          <tr>
            <td class="width40">
              <b-field label="参照可能営業所" labelPosition="on-border">
                <b-table
                  :data="data.referenceOfficeList"
                  checkable
                  :checked-rows.sync="referOfficeListSelected"
                  :header-checkable="false"
                  class="tableStyle"
                >
                  <template slot-scope="props">
                    <b-table-column field="officeCode">
                      {{ props.row.officeName }}
                    </b-table-column>
                  </template>
                </b-table>
              </b-field>
            </td>
            <td class="changeButtonColumn">
              <div>
                <b-button type="is-info" icon-right="chevron-double-left" @click="addOffice" />
                <div style="min-height:1em;"></div>
                <b-button type="is-info" icon-right="chevron-double-right" @click="deleteOffice" />
              </div>
            </td>
            <td class="width40">
              <b-table
                :data="officeMaster"
                checkable
                :checked-rows.sync="allOfficeListSelected"
                :header-checkable="false"
                class="tableStyle"
              >
                <template slot-scope="props">
                  <b-table-column field="officeCode">
                    {{ props.row.officeName }}
                  </b-table-column>
                </template>
              </b-table>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="columns">
      <div class="column" style="text-align:center;">
        <b-button
          :disabled="data.staffName==''"
          class="button"
          type="is-primary"
          icon-right="content-save"
          native-type="button"
          @click="doSave"
        >変更する</b-button>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import StaffSearchTemplate from "./AppSelectStaff";
var officeMaster = [];
const StaffChangeModalForm = {
  props: ["staffChange"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var selectedStaff = this.$refs.staffList.getStaff();
      if (selectedStaff) {
        //親画面のstaffChangedメソッドを呼び出し
        this.$emit("staff-change-event", selectedStaff);
        this.$parent.close();
      }
    }
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">ユーザ変更</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList"/>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};

export default {
  name: "AppUserManagementReferenceOffice",
  methods: {
    doSave: function(event) {
      var excuteApi = this.setReferenceOfficeListPOST;
      var successCallBack = this.setReferenceOfficeListSuccess;
      var errorCallBack = this.setReferenceOfficeListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setReferenceOfficeListPOST: function(client) {
      let officeCodeList = [];
      for (const office of this.data.referenceOfficeList) {
        officeCodeList.push(office.officeCode);
      }
      return client.apis.apiMaster.setReferenceOfficeListPOST({
        body: {
          id: this.data.id,
          referenceOfficeList: officeCodeList
        }
      });
    },
    setReferenceOfficeListSuccess: function(result) {
      this.$dialog.alert({
        title: "更新完了",
        message: "参照可能営業所情報を更新しました。"
      });
    },
    setReferenceOfficeListError: function(result) {
      this.showErrorMessage(result);
    },
    changeStaff: function(event) {
      // ユーザ担当者画面表示
      this.isManagerChangeActive = true;
    },
    staffChanged: function(staff) {
      // 名前を設定
      this.data.id = staff.id;
      this.data.staffName = staff.lastName + staff.firstName;
      // ロール
      this.data.role = staff.role;
      // 選択状態を解除
      this.referOfficeListSelected.splice(0);
      this.allOfficeListSelected.splice(0);

      //サーバーに参照可能範囲の営業所リストを問い合わせ
      var excuteApi = this.getReferenceOfficeListPOST;
      var successCallBack = this.getReferenceOfficeListSuccess;
      var errorCallBack = this.getReferenceOfficeListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getReferenceOfficeListPOST: function(client) {
      return client.apis.apiMaster.getReferenceOfficeListPOST({
        body: {
          id: this.data.id
        }
      });
    },
    getReferenceOfficeListSuccess: function(result) {
      //this.data.referenceOfficeListに営業所リストを設定
      this.data.referenceOfficeList = [];
      if (result.obj.length > 0) {
        for (const officeCode of result.obj[0].referenceOfficeList) {
          const office = this.officeMaster.find((item) => item.officeCode == officeCode);
          this.data.referenceOfficeList.push(office);
        }
      }
    },
    getReferenceOfficeListError: function(result) {
      this.showErrorMessage(result);
    },
    addOffice: function(event) {
      for (var i = 0; i < this.allOfficeListSelected.length; i++) {
      if (
        !this.isArrayExists(
          this.data.referenceOfficeList,
            this.allOfficeListSelected[i]
        )
      ) {
          this.data.referenceOfficeList.push(this.allOfficeListSelected[i]);
        }
      }
      this.referOfficeListSelected.splice(0);
      this.allOfficeListSelected.splice(0);
    },
    deleteOffice: function(event) {
      for (var i = 0; i < this.referOfficeListSelected.length; i++) {
        var target = this.referOfficeListSelected[i];
        var result = this.data.referenceOfficeList.filter(function(item) {
          return item.officeCode !== target.officeCode;
        });
        this.data.referenceOfficeList = result;
      }
      this.referOfficeListSelected.splice(0);
      this.allOfficeListSelected.splice(0);
    },
    isArrayExists: function(array, value) {
      // 配列の最後までループ
      for (var j = 0, len = array.length; j < len; j++) {
        if (value.officeCode == array[j].officeCode) {
          // 存在したらtrueを返す
          return true;
        }
      }
      // 存在しない場合falseを返す
      return false;
    }
  },
  data() {
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    return {
      data: {
        id: "",
        staffName: "",
        referenceOfficeList: []
      },
      officeMaster,
      isSaveCompleat: false,
      canManagerChangeActive: true,
      isManagerChangeActive: false,
      referOfficeListSelected: [],
      allOfficeListSelected: [],
      officeCode: "",
      staffCode: "",
      staffName: ""
    };
  },
  filters: {},
  components: {
    "staffChange-modal": StaffChangeModalForm
  }
};
</script>

<style lang="scss">
.changeButtonColumn {
  width: 60px;
  text-align: center !important;
  vertical-align: middle !important;
}
.width40 {
  width: 40%;
}
.tableStyle {
  border:solid 1px;
  border-color:lightgrey;
  table-layout: fixed;
  width: 100%;
  height:450px;
  overflow-y:scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementReferenceOffice.vue